import {
  DOWNLOAD_ALL_CONSTITUENTS,
  DOWNLOAD_DATA,
  GET_CONSTITUENT_OPTIONS,
  GET_DATA_ENRICHMENT_REQUEST,
  GET_DATA_HEALTH_STATS,
  GET_FIND_EMAIL_STATS,
  POST_DATA_ENRICHMENT_REQUEST,
  REQUEUE_NOT_SURE,
  receiveConstituentOptions,
  receiveDataEnrichmentRequest,
  receiveDataHealthStats,
  receiveFindEmailStats,
  receiveLastModifiedDate,
  SEND_CONFIRMATION_EMAILS,
  UPDATE_CONSTITUENT_OPTIONS,
} from "@/components/data/admin/ducks/Actions"
import {
  apiDownloadAllConstituents,
  apiDownloadData,
  apiGetConstituentOptions,
  apiGetDataEnrichmentRequest,
  apiGetDataHealthStats,
  apiGetFindEmailStats,
  apiPostDataEnrichmentRequest,
  apiRequeueNotSure,
  apiSendConfirmationEmails,
  apiUpdateConstituentOptions,
} from "@/components/data/admin/ducks/AJAX"
import { NavigationActions } from "@/components/navigation/ducks/slice"

export default (store) => (next) => (action) => {
  const { dispatch } = store
  const receiveLastModifiedDateSuccess = (cb) => (response) => {
    dispatch(receiveLastModifiedDate(response.lastModified))
    if (cb) {
      cb()
    }
  }
  const receiveConstituentOptionsSuccess = (cb) => (response) => {
    dispatch(receiveConstituentOptions(response))
    if (cb) {
      cb()
    }
  }
  const receiveEnrichmentRequestSuccess = (cb) => (response) => {
    if (cb) {
      cb()
    }
    dispatch(receiveDataEnrichmentRequest(response))
  }
  const receiveGetFindEmailStatsSuccess = (cb) => (response) => {
    if (cb) {
      cb()
    }
    if (response.emailsSent) {
      dispatch(
        NavigationActions.setSnackbar(
          `Sent confirmation emails to ${response.emailsSent} constituent${response.emailsSent === 1 ? "" : "s"}.`,
        ),
      )
    }
    dispatch(receiveFindEmailStats(response))
  }
  const receiveGetDataHealthStatsSuccess = (cb) => (response) => {
    if (cb) {
      cb()
    }
    dispatch(receiveDataHealthStats(response))
  }

  switch (action.type) {
    case DOWNLOAD_DATA:
      apiDownloadData(action.params, action.success, action.error)
      return next(action)

    case REQUEUE_NOT_SURE:
      apiRequeueNotSure(receiveGetFindEmailStatsSuccess(action.success), action.error)
      return next(action)

    case SEND_CONFIRMATION_EMAILS:
      apiSendConfirmationEmails(receiveGetFindEmailStatsSuccess(action.success), action.error)
      return next(action)

    case GET_FIND_EMAIL_STATS:
      apiGetFindEmailStats(receiveGetFindEmailStatsSuccess(action.success), action.error)
      return next(action)

    case GET_DATA_HEALTH_STATS:
      apiGetDataHealthStats(receiveGetDataHealthStatsSuccess(action.success), action.error)
      return next(action)

    case GET_DATA_ENRICHMENT_REQUEST:
      apiGetDataEnrichmentRequest(receiveEnrichmentRequestSuccess(action.success), action.error)
      return next(action)

    case POST_DATA_ENRICHMENT_REQUEST:
      apiPostDataEnrichmentRequest(receiveEnrichmentRequestSuccess(action.success), action.error)
      return next(action)

    case GET_CONSTITUENT_OPTIONS:
      apiGetConstituentOptions(
        action.query,
        receiveConstituentOptionsSuccess(action.success),
        action.error,
      )
      return next(action)

    case UPDATE_CONSTITUENT_OPTIONS:
      apiUpdateConstituentOptions(
        action.params,
        receiveConstituentOptionsSuccess(action.success),
        action.error,
      )
      return next(action)

    case DOWNLOAD_ALL_CONSTITUENTS:
      apiDownloadAllConstituents(receiveLastModifiedDateSuccess(action.success), action.error)
      return next(action)

    default:
      return next(action)
  }
}
